/* ── Category definitions ── */
export const CATEGORIES = {
  promotion:      { label: 'Promotion',      color: 'bg-purple-100 text-purple-700',   dot: 'bg-purple-500' },
  merit_increase: { label: 'Merit Increase', color: 'bg-emerald-100 text-emerald-700', dot: 'bg-emerald-500' },
  equity_grant:   { label: 'Equity Grant',   color: 'bg-cyan-100 text-cyan-700',       dot: 'bg-cyan-500' },
  bonus_change:   { label: 'Bonus Change',   color: 'bg-amber-100 text-amber-700',     dot: 'bg-amber-500' },
  role_change:    { label: 'Role Change',    color: 'bg-rose-100 text-rose-700',       dot: 'bg-rose-500' },
};

export const CATEGORY_OPTIONS = Object.entries(CATEGORIES).map(([value, { label }]) => ({
  value,
  label,
}));

export const CURRENCIES = [
  { value: 'USD', symbol: '$' },
  { value: 'EUR', symbol: '€' },
  { value: 'GBP', symbol: '£' },
  { value: 'ILS', symbol: '₪' },
  { value: 'SGD', symbol: 'S$' },
  { value: 'BRL', symbol: 'R$' },
  { value: 'INR', symbol: '₹' },
  { value: 'CNY', symbol: 'CN¥' },
];

export const CYCLE_STATUSES = {
  draft:     { label: 'Draft',     color: 'bg-surface-200 text-navy-500',     ring: 'ring-navy-200' },
  active:    { label: 'Active',    color: 'bg-emerald-100 text-emerald-700',  ring: 'ring-emerald-200' },
  completed: { label: 'Completed', color: 'bg-blue-100 text-blue-700',        ring: 'ring-blue-200' },
};

export const PAY_TYPES = [
  { value: 'annual', label: 'Annual' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'hourly', label: 'Hourly' },
];

export const GRANT_TYPES = [
  { value: 'RSU', label: 'RSU' },
  { value: 'stock_options', label: 'Stock Options' },
  { value: 'performance_shares', label: 'Performance Shares' },
];

export const VARIABLE_DISPLAY_TYPES = [
  { value: 'amount', label: 'Amount ($)' },
  { value: 'percent', label: 'Percentage (%)' },
];

export const EQUITY_GRANT_CATEGORIES = [
  { value: 'promotion', label: 'Promotion Grant' },
  { value: 'performance', label: 'Performance Grant' },
  { value: 'refresh', label: 'Refresh Grant' },
];

export const DEV_ACCOUNTS = [
  { email: 'alex.chen@forter.com',    label: 'Admin',              description: 'Full admin access' },
  { email: 'riley.chen@forter.com',   label: 'Top Communicator',   description: 'Has team tab (subordinate communicators)' },
  { email: 'dakota.chen@forter.com',  label: 'Mid Communicator',   description: 'Communicator with direct reports' },
  { email: 'jamie.chen@forter.com',   label: 'Leaf Communicator',  description: 'Communicator with employees only' },
  { email: 'jordan.chen@forter.com',  label: 'People Partner',     description: 'PP with assigned communicators' },
  { email: 'river.chen@forter.com',   label: 'Employee',           description: 'Views own compensation' },
];

export const EMPTY_COMPENSATION = {
  employeeEmail: '',
  employeeName: '',
  department: '',
  communicatorEmail: '',
  communicatorName: '',
  category: 'promotion',
  currency: 'USD',
  payType: 'annual',
  variableDisplayType: 'amount',
  currentTitle: '',
  newTitle: '',
  currentBase: 0,
  newBase: 0,
  currentVariableTarget: 0,
  newVariableTarget: 0,
  equityGrants: [],
  totalCurrentComp: 0,
  totalNewComp: 0,
  effectiveDate: '',
  payDate: '',
  notes: '',
};
